import {useState} from "react"

const initFromSession = (sessionName, initialState) => {
    if (sessionName && sessionStorage.getItem(sessionName))
        return sessionStorage.getItem(sessionName)
    return initialState
}

export const useFlag = (initialState = null, sessionName = null) => {
    const [flag, setFlag] = useState(() => initFromSession(sessionName, initialState))

    const setFlagPlugin = flag => {
        if (sessionName && flag) sessionStorage.setItem(sessionName, flag)
        if (sessionName && !flag) sessionStorage.removeItem(sessionName)

        setFlag(flag)
    }

    return {
        set: flag => setFlagPlugin(flag),
        get: () => flag,
        unset: () => setFlagPlugin(null),
        is: isFlag => flag === isFlag
    }
}
